<template>
    <div class="cnoilContainer">
        <!-- 顶部 -->
        <Top @change-Language="changeLanguage" :type="'index'" :catalogList="detailsText"></Top>
        <div v-if="showAll">
            <!-- banner -->
            <Banner :bannerText="bannerText" :type="'index'" style="margin-top: 7vh;"></Banner>
            <!-- 查看详情 -->
            <div class="details">
            <!-- 选择框 -->
            <div class="selectBox">
                <div class="SelectName">{{modular.Name}}</div>
                <div class="checkBox">
                    <div>{{message('更多植物','More Plants')}}</div>
                    <Select v-model="selectDetailsType" style="width:100px" @on-change="changeKeywords" size="large" class="checType">
                        <Option v-for="(item,index) in detailsType" :key="index" :value="item">{{ item }}</Option>
                    </Select>
                </div>
            </div>
            <!-- 详情块 -->
            <div class="detail" v-if="isWideScreen" @mouseenter="showIcons = true" @mouseleave="showIcons = false">
                <Icon v-if="showLeftIcons && showIcons" type="ios-arrow-back" class="leftIcon" size="60" @click="moveLeft"/>
                <div v-for="(item, index) in detailsShowText" :key="index" class="videoItem"  :style="{ transform: `translateX(${translateX}%)` }"  @click="goToDetail(item.Url)">
                    <div @mouseenter="playVideo(index)" @mouseleave="pauseVideo(index)" class="showBox"  style="cursor: pointer">
                        <video :ref="'video' + index" :src="item.ExtString1" muted class="detailVideo"  v-show="item.ExtString1 && (enterIndex == index)" preload="auto"  style="cursor: pointer"  loop></video>
                        <img :src="item.Pic" alt="" class="detailVideo" v-show="!(item.ExtString1 && (enterIndex == index))"  style="cursor: pointer">
                        <div class="deatilText"  style="cursor: pointer">
                            <div class="deatilTextTitle">{{item.Title}}</div>
                            <div>{{item.SubTitle}}</div>
                            <div>{{item.Flag2}} <Icon type="ios-arrow-forward" /></div>
                        </div>
                    </div>
                </div>
                <Icon v-if="showRightIcons && showIcons" type="ios-arrow-forward" class="rightIcon" size="60" @click="moveRight"/>
            </div>
            
            <Row class="phoneDetail" v-else>
                <Col span="24" v-for="(item, index) in detailsShowText" :key="index" class="phoneVideoBox">
                    <img :src="item.Pic" alt="" class="phoneVideo"   @click="goToDetail(item.Url)">
                    <div class="deatilText"   @click="goToDetail(item.Url)">
                        <div class="deatilTextTitle">{{item.Title}}</div>
                        <div>{{item.SubTitle}}</div>
                        <div>{{item.Flag2}} <Icon type="ios-arrow-forward" /></div>
                    </div>
                </Col>
            </Row>

            </div>
            <!-- <div class="downLoad">
                <Button type="primary" ghost class="downLoadBtn" @click="goDownLoad" size="large" >{{downLoad.Flag2}}</Button>
            </div> -->

            <img src="@/assets/OilFeedback.png" alt="" class="feedback" @click="feedBack" v-if="!isWideScreen">
            <Modal v-model="showFeedbackModal" title='留言反馈' :styles='{width:"640px",top:"50px"}'  footer-hide>
                <Feedback v-if='showFeedbackModal'/>
            </Modal>
        </div>
        <loading class='loading' v-if="isLoad"/>
    </div>
</template>

<script>
    import Top from './component/cnoilTop.vue'
    import Banner from './component/cnoilBanner.vue'
	import Feedback from '@/components/common/Feedback'
    import loading from '@/components/order/loading'

	import {
        mapState,
		mapActions,
        mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
                // 是否加载完毕
                showAll: false,
                isLoad: false,
                load: null,
                // banner数据
                bannerText: {},
                // 详情数据
                modular: {},
                detailsText: [],
                detailsShowText: [],
                // 详情类型
                detailsType: [],
                selectDetailsType: '',
                // 详情左右切换
                showLeftIcons: false,
                showRightIcons: true,
                showIcons: false,
                translateX: 0,
                enterIndex: -1,
                isThrottled: false,
                // 屏幕宽度
                screenWidth: window.innerWidth,
                // 留言反馈
                showFeedbackModal: false,
                // 底部下载按钮
                downLoad: {},
                // 定时器清理
                timeoutId: null
                
			}
		},
		created() {
            this.$nextTick(function() {
				this.initData()
			})
		},
        beforeDestroy() {
            if (this.load) {
                clearTimeout(this.load);
            }
        },
		mounted() {
            window.addEventListener('resize', this.handleResize);  
		},
		watch:{

		},
        
		mixins:[],
		components: {
            Top,
            Feedback,
            Banner,
            loading
		},
		computed: {
            isWideScreen() {  
                return this.screenWidth >= 768;  
            },
            ...mapState({
                setLanguage: state => state.common.setLanguage,
            }),
		},
		methods: {
            ...mapActions([
				'getPageConfigAction',
				'getPageConfigDetailAction',
				'initProductAction',
                'recordBrowsingAction'
			]),
            ...mapMutations([
                "SET_LANGUAGE",
            ]),
            async initData() {
                this.load = setTimeout(() => {
                    this.isLoad = true
                }, 500)
                if(!this.setLanguage) {
                    this.SET_LANGUAGE('ZH')
                }
				this.changeLanguage(this.setLanguage.toUpperCase())
            },
            // 中英文切换
            async changeLanguage(val) {
                if(val == 'ZH') {
                    this.modulars = await this.getPageConfigAction('WSChinaOil')
                    this.res = await this.getPageConfigDetailAction({page:'WSChinaOil'})
                    this.all = '所有'
                } else {
                    this.modulars = await this.getPageConfigAction('WSChinaOil-English')
                    this.res = await this.getPageConfigDetailAction({page:'WSChinaOil-English'})
                    this.all = 'All'
                }
                if(this.res.length > 0 && this.modular) {
                    this.bannerText = this.res[0]
                    this.detailsText = this.res.slice(1, -1)
                    this.detailsShowText = this.detailsText
                    this.downLoad = this.res[this.res.length - 1]
                    this.detailsType = [this.all, ...new Set(this.detailsText.map(item => item.Keywords))]
                    this.selectDetailsType = this.all
                    this.modular = this.modulars[1]
                    clearTimeout(this.load)
                    this.isLoad = false
                    this.showAll = true
                }
            },
            // 选择明细类型
            changeKeywords(val) {
                this.translateX = 0
                this.showLeftIcons = false
                if(val == '所有' || val == 'All') {
                    this.detailsShowText = this.detailsText
                } else {
                    this.detailsShowText = this.detailsText.filter(item => item.Keywords == val)
                }
                this.showRightIcons = this.detailsShowText.length > 2;
            },
            // 鼠标悬浮离开控制视频播放停止
            playVideo(index) {
                if(!this.detailsShowText[index].ExtString2) return
                if(this.timeoutId) {
                    clearTimeout(this.timeoutId)
                }
                this.timeoutId = setTimeout(() => {
                    this.enterIndex = index;
                    const videoElement = this.$refs['video' + index];
                    if (videoElement && videoElement[0]) {
                        videoElement[0].play();
                    } else if (videoElement && videoElement instanceof HTMLVideoElement) {
                        videoElement.play();
                    }
                }, 290)
            },
            pauseVideo(index) {
                if(this.timeoutId) {
                    clearTimeout(this.timeoutId)
                }
                this.enterIndex = -1;
                const videoElement = this.$refs['video' + index];
                if (videoElement && videoElement[0]) {
                    videoElement[0].pause();
                    videoElement[0].currentTime = 0;
                } else if (videoElement && videoElement instanceof HTMLVideoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                }
            },
            // 详情左右切换
            moveLeft() {
                if(this.isThrottled) return
                this.isThrottled = true

                let maxTranslateX = -((this.detailsShowText.length - 2) * 100) 
                if(this.translateX < 0) {
                    if(this.translateX == maxTranslateX || this.translateX+50 == 0) {
                        this.translateX += 50
                    }else {
                        this.translateX += 100
                    }
                }else {
                    this.translateX = 0
                }
                if(this.translateX > -50) {
                    this.showLeftIcons = false
                }
                this.showRightIcons = true

                setTimeout(() => {
                    this.isThrottled = false;
                }, 800);
            },
            moveRight() {
                if(this.isThrottled) return
                this.isThrottled = true

                let maxTranslateX = -((this.detailsShowText.length - 2) * 100) 
                
                if(this.translateX > maxTranslateX) {
                    if(this.translateX == 0 || this.translateX - 50 == maxTranslateX) {
                        this.translateX -= 50
                    }else {
                        this.translateX -= 100
                    }
                }else {
                    this.translateX = maxTranslateX
                }
                if(this.translateX <= maxTranslateX) {
                    this.showRightIcons = false
                }
                this.showLeftIcons = true

                setTimeout(() => {
                    this.isThrottled = false;
                }, 800);

            },


            goDownLoad() {
                this.recordBrowsingAction({
                    PreRoute:this.$route.path,
                    PageCode:'/cnoil/download',
                    MainId:'',
                    extend:'',
                })
                window.open(`${this.downLoad.Url}`)
            },

            // 判断屏幕宽度
            handleResize() {
                this.screenWidth = window.innerWidth; 
            },
            // 留言反馈
            feedBack() {
                this.showFeedbackModal = true
            },
            // 跳转详情
            goToDetail(url) {
                location = url
                window.scrollTo(0, 0);
            },


            message(ZH,EN){
				return this.setLanguage.toUpperCase() === 'ZH' ? ZH : EN;
			},
        }
	}
</script>




<style scoped lang="scss">
@import "@/style/mixin";
@import "@/style/common";

.cnoilContainer {
    margin-bottom: 40px;
    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 5vh;
        padding: 0 2vw;
        background-color: $blue;
        font-size: 14px;
        color: #fff;
        img {
            width: 4vh;
            height: 4vh;
        }
        .langSelect {
            background-color: transparent
        }
    }
    
    .details {
        margin: 0 10px;
        .selectBox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 5vh;
            line-height: 5vh;
            text-align: center;
            margin: 10px;
            font-size: 18px;
            .checkBox {
                display: flex;
                align-items: center;
                .checType {
                    margin-left: 10px;
                }
            }
        }
        .detail {
            display: flex;
            flex-wrap: nowrap;
            overflow: hidden;
            position: relative;

            .videoItem {
                flex: 1 0 50%;
                box-sizing: border-box;
                transition: transform 0.8s cubic-bezier(0.5, 0, 0.5, 1);
                max-width: 50%;
                padding: 10px;
                max-height: 27.5vw;
                .detailVideo {
                    border-radius: 0.1rem;
                    width: 100%;
                    height: auto;
                    max-height: 26.5vw;
                    object-fit: cover;
                }
                .deatilText {
                    position: absolute;
                    bottom: 14%;
                    left: 7%;
                    color: #fff;
                    .deatilTextTitle {
                        @include fontSize($font-size-25);
                        margin-bottom: 5px
                    }
                }
                .showBox {
                    height: 100%;
                    border-radius: 0.1rem;
                    overflow: hidden;
                    img {
                        border-radius: 0.1rem;
                        transition: transform 0.3s ease;
                    }
                    img:hover{ 
                        transform: translate(0,0) scale(1.2);
                    }
                }
            }
            .rightIcon, .leftIcon {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: #e5e5e5;
                z-index: 10;
                cursor: pointer
            }
            .rightIcon:hover, .leftIcon:hover {
                color: #fff;
                background-color: rgba(0, 0, 0, 0.1);
            }
            .rightIcon {
                right: 10px;
            }
            .leftIcon {
                left: 10px;
            }
        }
        .phoneDetail {
            .phoneVideoBox {
                margin: 5px 0;
                max-height: 55vw;
                .phoneVideo {
                    width: 100%;
                    border-radius: 2vw;
                    max-height: 55vw;
                }
                .deatilText {
                    position: absolute;
                    bottom: 10%;
                    left: 5%;
                    color: #fff;
                    font-size: 4vw;
                    .deatilTextTitle {
                        font-size: 6vw;
                        margin-bottom: 5px
                    }
                }
            }
        }
    }
    .downLoad {
        display: flex;
        justify-content: center;
        margin: 20px 0;
        .downLoadBtn {
            color:#505d61;
            border-color: #505d61;
            background-color: rgba(0, 0, 0, 0.1)
        }
        .downLoadBtn:focus {
            box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
            outline: none;
        }
        .downLoadBtn:hover {
            background-color: rgba(0, 0, 0, 0.2)
        }
    }
    .feedback{
        position: fixed;
        bottom: 10%;
        right: 1%;
        width: 40px;
    }
}

@media (max-width: 768px) {
    .details{
        .selectBox {
            font-size: 16px !important;
            margin: 10px 0 !important;
            .SelectName {
                color: #bd8bca;
            }
        }
    }
}
</style>

<style lang="scss">
.cnoilContainer {
    .checkBox {
        .ivu-select-selected-value {
            font-size: 18px !important;
        }
        .ivu-select-dropdown {
            right: 20px;
            left: auto !important
        }
        .ivu-select-large .ivu-select-item {
            font-size: 18px !important;
        }
    }
    @media (max-width: 768px) {
    .checkBox {
        .ivu-select-selected-value {
            font-size: 16px !important;
        }
        .ivu-select-dropdown {
            right: 10px;
            left: auto !important
        }
        .ivu-select-large .ivu-select-item {
            font-size: 16px !important;
        }

    }
}
}
</style>
